import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const fieldSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.field, {
        base: {
            label: {
                fontWeight: 400,
                m: 0,
            },

            errorText: {
                fontWeight: 400,
            },
        },
    }),
);
